export type JWTResponse = {
  jwttoken: string;
}

export type JWTSubject = {
  sub: string;
  companyId: string;
  isExpired: boolean;
  expiration: number;
}

export type JWTWebToken = {
  iss?: string;
  sub: string;
  aud?: string;
  exp: number;
  iat: number;
  companyId: string;
}

/**
 * JWT周りの処理基底クラス
 */
class JWTUtils {
  /**
   * コンストラクタ
   * @param {*} jwtKey localStorage にjwttokenを保存するキー
   */
  constructor (private jwtKey: string) {
    this.jwtKey = jwtKey
  }

  // localStorageにJWTトークンを保存
  save (jwt: string): void {
    localStorage.setItem(this.jwtKey, jwt)
  }

  // localStorageからJWTトークンを取得
  get (): string | null {
    return localStorage.getItem(this.jwtKey)
  }

  // localStorageのJWTトークンを削除
  logout (): void {
    localStorage.removeItem(this.jwtKey)
  }

  // ログイン時のレスポンスから、JWTトークンを抽出
  extract (responseBody: JWTResponse): string {
    return responseBody.jwttoken
  }

  decode (jwt: string): JWTWebToken {
    const base64Url = jwt.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(decodeURIComponent(escape(window.atob(base64))))
  }

  // JWTトークンを解析し、UserID を抽出する
  getSubject (jwt: string): JWTSubject {
    const obj = this.decode(jwt)
    return {
      sub: obj.sub,
      companyId: obj.companyId,
      isExpired: this.isExpired(obj.exp),
      expiration: obj.exp - obj.iat
    }
  }

  // 期限切れか
  isExpired (exp: number): boolean {
    return new Date() > new Date(exp * 1000)
  }
}

const jwtKey = process.env.VUE_APP_JWT_KEY || 'jwtCustomerOnline'
export default new JWTUtils(jwtKey)
